import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { MediaItem } from '@/components/FigurineGallery';

export function useFigurineImages(figurineId: string) {
  const [items, setItems] = useState<MediaItem[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await supabase
      .from('figurine_images')
      .select('*')
      .eq('figurine_id', figurineId)
      .order('order_index');
    setItems((data ?? []) as MediaItem[]);
    setLoading(false);
  };

  useEffect(() => {
    if (figurineId) load();
  }, [figurineId]);

  return { items, loading, reload: load };
}
